import React, { Component, createRef, forwardRef } from 'react';
import { object, objectOf, array, string, instanceOf } from 'prop-types';
import Line from './line';

export default class extends Component {

    static propTypes = {
        chart: object.isRequired,
        data: array.isRequired,
        disclaimer: object,
        pageWrapper: object.isRequired,
        componentWrapper: object.isRequired,
        overlay: objectOf( string ).isRequired,
        saveButton: instanceOf( HTMLElement )

    };
    constructor( props ) {

        super( props );

        this.svg = createRef();
        this.state = {
            width: this.props.componentWrapper.offsetWidth
        };

    }

    componentDidMount() {

        window.addEventListener( 'resize', this.handleResize );

    }

    componentWillUnmount() {

        window.removeEventListener( 'resize', this.handleResize );

    }

    handleResize = () => {

        const width = this.props.componentWrapper.offsetWidth;

        if ( width === this.state.width ) return;

        this.setState( { width } );

    };

    render() {

        const height = 680;
        const margin = {
            top: 130,
            right: 25,
            bottom: 145,
            left: 58
        };

        const Chart = forwardRef( ( props, ref ) => (
            <Line
                svgRef={ ref }
                data={ this.props.data }
                chart={ this.props.chart }
                height={ height }
                width={ this.state.width }
                margin={ margin }
                disclaimer={ this.props.disclaimer }
                pageWrapper={ this.props.pageWrapper }
                componentWrapper={ this.props.componentWrapper }
                overlay={ this.props.overlay }
            />
        ) );

        return (
            <Chart ref={ this.svg } />
        );

    }

}
